export default function ResponsibleGamblingBanner() {
  return (
    <div
      data-testid="rg-banner"
      className="fixed bottom-0 left-0 right-0 z-30 text-black font-bold text-[11px] sm:text-xs py-2 px-4 flex items-center justify-center gap-2 text-center"
      style={{ background: "#FFCC00", letterSpacing: "0.04em" }}
    >
      <span>18+</span>
      <span aria-hidden>·</span>
      <span>Please Gamble Responsibly</span>
      <span aria-hidden>·</span>
      <a
        href="https://www.begambleaware.org/"
        target="_blank"
        rel="noopener noreferrer"
        className="underline underline-offset-2"
      >
        BeGambleAware.org
      </a>
    </div>
  );
}
